import * as React from "react";
import { cn } from "../shared/ui/index.ts";
import {
  AdvancedGrid,
  type GridColumn,
} from "../shared/advanced-grid/advanced-grid.component.tsx";

interface Task {
  id: string;
  label: string;
  count: number;
  urgent: boolean;
}

const TASKS: Task[] = [
  {
    id: "t1",
    label: "Signer les ordonnances en attente",
    count: 4,
    urgent: true,
  },
  { id: "t2", label: "Compte-rendu — Mme Bernard", count: 1, urgent: false },
  { id: "t3", label: "Rappeler le laboratoire Cerba", count: 1, urgent: false },
  { id: "t4", label: "Valider les arrêts de travail", count: 2, urgent: false },
];

export function TasksGridWidget({ panelId }: { panelId: string }) {
  const [done, setDone] = React.useState<string[]>([]);

  const columns: GridColumn<Task>[] = [
    {
      id: "done",
      label: "Fait",
      accessor: (r) => (done.includes(r.id) ? 1 : 0),
      sortable: true,
      width: "60px",
      align: "center",
      render: (r) => (
        <input
          type="checkbox"
          checked={done.includes(r.id)}
          onChange={() =>
            setDone((d) =>
              d.includes(r.id) ? d.filter((x) => x !== r.id) : [...d, r.id],
            )
          }
          onClick={(e) => e.stopPropagation()}
          className="size-4 accent-sf-primary"
        />
      ),
    },
    {
      id: "label",
      label: "Tâche",
      accessor: (r) => r.label,
      sortable: true,
      render: (r) => (
        <span
          className={cn(
            done.includes(r.id) && "text-sf-text-muted line-through",
          )}
        >
          {r.label}
        </span>
      ),
    },
    {
      id: "count",
      label: "Compteur",
      accessor: (r) => r.count,
      sortable: true,
      width: "90px",
      align: "right",
    },
    {
      id: "urgent",
      label: "Urgent",
      accessor: (r) => (r.urgent ? 1 : 0),
      sortable: true,
      width: "80px",
      align: "center",
      render: (r) =>
        r.urgent ? (
          <span className="inline-flex items-center rounded border border-sf-danger/25 bg-sf-danger/10 px-1.5 py-px text-[10px] font-semibold text-sf-danger">
            URGENT
          </span>
        ) : null,
    },
  ];

  return (
    <AdvancedGrid<Task>
      instanceId={panelId}
      columns={columns}
      rows={TASKS}
      rowKey={(r) => r.id}
      emptyMessage="Aucune tâche."
    />
  );
}
